// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"93fed395","667":"dc3759a1"}[chunkId] + ".chunk.js";
};